import React from "react";
import { Button } from "../../../components/common";
import { Download } from "../../../components/common/Icons";
import type { DownloadIconType } from "../../../components/common/Icons/Download";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./ParagraphFileDownload.module.scss";
interface ParagraphFileDownloadProps {
	fileUrl: string;
	fileSize: string;
	fileLabel: string;
}

export const getParagraphFileDownloadProps = ({
	downloadUrl,
	fileSize,
	field_download_label,
}: Queries.ParagraphFileDownloadDataFragment): ParagraphFileDownloadProps => ({
	fileUrl: downloadUrl,
	fileSize: fileSize,
	fileLabel: field_download_label,
});
export const ParagraphFileDownload: React.FC<ParagraphFileDownloadProps> = ({
	fileUrl,
	fileSize,
	fileLabel,
}) => {
	if (!fileUrl || fileUrl.length === 0) return null;
	const fileArray = fileUrl.split(".");
	if (!fileArray || fileArray.length === 0) return null;
	const fileType = fileArray[fileArray.length - 1];
	if (!fileType) return null;

	const getDownloadType = (): DownloadIconType => {
		switch (fileType) {
			case "pdf":
				return "pdf";
			case "docx":
			case "doc":
				return "doc";
			case "xls":
			case "xlsx":
				return "sheet";
			case "pptx":
			case "ppt":
				return "ppt";
			case "mp3":
				return "mp3";
			case "jpg":
			case "jpeg":
			case "png":
				return "image";
			default:
				return "doc";
		}
	};
	return (
		<WrappedSection sectionName="ParagraphFileDownload">
			<div className={styles.inner}>
				<div className={styles.downloadcard}>
					<div className={styles.left}>
						<div className={styles.iconarea}>
							<Download
								type={getDownloadType()}
								height={"50px"}
								width={"50px"}
							/>
						</div>
						<div className={styles.textarea}>
							<div className={styles.filemeta}>{`${fileType} ${fileSize}`}</div>
							<div className={styles.filename}>{fileLabel}</div>
						</div>
					</div>
					<div className={styles.buttonarea}>
						<Button
							variant={"secondary"}
							url={fileUrl}
							IconRight={() => (
								<Download fill={Colours.WHITE} height={"60px"} width={"60px"} />
							)}
						>
							Download
						</Button>
					</div>
				</div>
			</div>
		</WrappedSection>
	);
};
